/**
 * Created by rathompson on 12/29/21
 * File: LabelConstants
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const BUTTON_ACTIVATE_NOW = 'Activate Now'
export const BUTTON_ACTIVATE = 'Activate'
export const BUTTON_ACTIVATING = 'Activating'
export const BUTTON_LAUNCH = 'Launch'
export const BUTTON_ERROR = 'Error'

export const SASE_SELECT_ACCOUNT = 'Customer Support Portal Account'
export const SASE_SELECT_TENANT = 'Tenant'
export const SASE_SELECT_REGION = 'SASE Region'
export const SELECT_REGION = 'Region'
export const SASE_SELECT_CDL = 'Cortex Data Lake'
export const SASE_NUM_ANTICIPATED = 'Total Number of Anticipated Devices'
export const SASE_SELECT_ACCOUNT_SUBTEXT = 'Choose the account you would like to attach this license to.'
export const SASE_SELECT_TENANT_SUBTEXT = 'Choose the Tenant you would like to attach this license to.'
export const SASE_SELECT_REGION_SUBTEXT = 'Choose the region closest to where the data logs will be written and stored.'
export const SASE_SELECT_CDL_SUBTEXT = 'Choose the data lake you would like to use.'
export const SASE_SELECT_ANTICIPATED_SUBTEXT = 'This helps in planning for device telemetry storage.'
export const SASE_SELECT_APP_REGION_SUBTEXT = 'Choose the region where the {0} app instance to be onboarded.'

export const ACTIVATION_READY = 'Ready for Activation'
export const ACTIVATED = 'Activated'
export const ACTIVATING = 'Activating'
export const ENTERPRISE_TITLE = 'Prisma SASE'
export const AVAILABLE_IN_TENANT = 'Available in this tenant'

export const CLOUD_MGMT_LABEL = 'Cloud-Managed'
export const CLOUD_MGMT_DESC = 'Cloud-managed by default. Toggle this off to manage via Panorama.'

export const AVAILABLE_ADD_ONS = 'Add-ons Available'

export const LABEL_AGREE_TERMS = 'Agree to the Terms and Conditions'
export const AGREE_TERMS_PREFIX = 'Agree to the '
export const LINK_TERMS = 'Terms and Conditions'

export const LABEL_EXPIRES = 'Expires:'

export const LABEL_TAKING_LONGER_THAN_USUAL = 'This is taking longer than usual...'

export const ERROR_TSG_ALREADY_HAS_CGX = 'Selected Tenant already has an SDWAN instance'
export const ERROR_TSG_ALREADY_HAS_PANORAMA = 'Selected Tenant has an PANORAMA instance, use other tsg to claim the license'
export const ERROR_TSG_ALREADY_HAS_PRISMA_ACCESS = 'Selected Tenant already has a Prisma Access instance'
export const ERROR_TSG_ALREADY_HAS_OTHER_REGION = 'Selected Tenant already has instances in other than china region'
export const ERROR_PANORAMA_INVALID = 'Serial Number is invalid'
export const ERROR_TSG_ALREADY_HAS_CDL_ACCESS = 'Selected Tenant already has a CDL instance'
export const ERROR_SDWAN_NOT_FOR_ONPREM = 'Prisma SD-WAN add-on cannot work with Panorama Managed PAE'
export const CHINA_REGION = 'cn'
export const ERROR_TSG_HAS_PAN_CHINA = 'Selected Tenant has an PA China license, use other tsg to claim the license'

//To override the display_name from license info (Magic Link)
export const CUSTOM_ACTIVATION_TITLE = {
  'prisma_access': 'Prisma SASE',
  'logging_service': 'Cortex Data Lake',
}
export const CAN_BE_USED_ON = 'Can Be Used On'
export const APP_NOTES = {
  'ng_casb': 'A valid Cortex Data Lake instance is required for this product.'
}
export const SINGLE_TENANT_DROPDOWN_HEADERS = [SASE_SELECT_TENANT_SUBTEXT, SASE_SELECT_ACCOUNT_SUBTEXT]
export const CDL_MIGRATION_MSG = 'Please note that the CDL app will now be accessible on hub 2.0 (dark mode) or under “view by tenants”'
